import Vue from 'vue'
import Root from './Root.vue'
// @ts-ignore
import VueVirtualScroller from 'vue-virtual-scroller'
import router from './router'
import { store } from './store'
// @ts-ignore
import { VTooltip, VClosePopover } from 'v-tooltip'
import './setup'
import './registerServiceWorker'

import { eventBus } from '@/plugins/eventBus'
import locationManager from '@/plugins/locationManager'
import socketManager from '@/plugins/socketManager'
import Vuelidate from 'vuelidate'
// @ts-ignore
import vuelidateErrorExtractor from 'vuelidate-error-extractor'
import InputValidator from './components/inputsV2/InputValidator.vue'
// @ts-ignore
import VueCookies from 'vue-cookies'

import { Component } from 'vue-property-decorator'
import MirrorWebsocket from '@/plugins/mirrorWebsocket'
import Vue2Filters from 'vue2-filters'
const VueDragResize = require('vue-drag-resize').default
const VueTheMask = require('vue-the-mask').default

Component.registerHooks(['validations'])
Vue.config.productionTip = false
Vue.component('vue-drag-resize', VueDragResize)
Vue.directive('tooltip', VTooltip)
Vue.use(Vue2Filters)
Vue.use(Vue2Filters)
Vue.use(VueTheMask)
Vue.use(VueVirtualScroller)
Vue.use(VueCookies, { expires: '7d', path: '/' })
Vue.use(eventBus)
Vue.use(locationManager)
Vue.use(socketManager)
Vue.use(new MirrorWebsocket(router))
Vue.use(Vuelidate)
Vue.use(vuelidateErrorExtractor, {
  template: InputValidator,
  messages: {
    required: 'The field is required',
    unique: 'The field must be unique',
    email: 'Email is invalid',
    minLength: 'Min Length: {length}',
    maxLength: 'Max length: {length}',
    minValue: 'Min value: {value}',
    maxValue: 'Max value: {value}',
    checked: 'Must be checked',
    hasNumber: 'Must have at least one number',
    hasUpperLetter: 'Must have at least one upper case letter',
    passwordMatch: 'Passwords must match',
    integer: 'Must be an integer',
    positive: 'Must be an positive',
    numeric: 'Must be a number',
    phone: 'Phone number is invalid',
    valid: 'Field is invalid',
    validCC: 'Invalid card number'
  }, // error messages to use
  attributes: { // maps form keys to actual field names
    email: 'Email',
    first_name: 'First name',
    last_name: 'Last name'
  }
})

Vue.directive('close-popover', VClosePopover)

new Vue({
  router,
  store,
  render: h => h(Root),
  validations: {}
}).$mount('#app')
